$('.info_phones').on('click', 'button', function () {
    $('.info_phones').find('.info_phones-drop').stop().slideToggle();
});

$('.account').on('click', 'button', function () {
    if ($(this).parent().is('.singed') && $(window).width() < 768) {
        if($('.singed-menu').is(':visible')){
            $('.singed-menu').stop().slideUp();
            $(this).find('.arr').css({
                transform: 'rotate(0)'
            })
        } else {
            $('.singed-menu').stop().slideDown();
            $(this).find('.arr').css({
                transform: 'rotate(180deg)'
            })
        }
    }
});

let accountTimer;
$('.account').on('mouseenter', function () {
    if ($(this).is('.singed') && $(window).width() > 768) {
        $(this).find('.arr').css({
            transform: 'rotate(180deg)'
        });
        $('.singed-menu').stop().slideDown();
        clearTimeout(accountTimer);
    }
});

$('.account').on('mouseleave', function () {
    if ($(this).is('.singed') && $(window).width() > 768) {
        accountTimer = setTimeout(function () {
            $('.account').find('.arr').css({
                transform: ''
            });
            $('.singed-menu').stop().slideUp();
        }, 700);
    }
});

$('.mob-menu').on('click', function () {
    $('nav').css('left', '0');
});

$('nav').on('click', '.close', function () {
    $('nav').css('left', '');
});

$('.info').on('click', function () {
    if ($(window).width() < 768) {
        $('.mob-popup').fadeIn();
    }
});

$('.popup-close').on('click', function () {
    if ($(window).width() < 768) {
        $('.mob-popup').fadeOut();
    }
});

let availableTags = [
    "ActionScript",
    "AppleScript",
    "Asp"
];

$('.autocomplete-1').autocomplete({
    source: availableTags,
    appendTo: '.search-1'
});
$('.autocomplete-2').autocomplete({
    source: availableTags,
    appendTo: '.search-2'
});
$('.ui-helper-hidden-accessible').remove();


// WEBPACK FOOTER //
// ./css/bem/header/head/_head.js